import showNotification from './notifications';

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found');
}

window.initAjaxForm = function() {
    let ajaxForms = document.querySelectorAll('.ajax-form');

    ajaxForms.forEach(form => {
        form.addEventListener('submit', function(event) {
            event.preventDefault();
            requestBeforeSubmit(form);
            makeRequest(form, event);
        }, false)
    });
}

window.initAjaxButton = function() {

    let ajaxButtons = document.querySelectorAll('.ajax-button');

    ajaxButtons.forEach(btnAjax => {
        btnAjax.addEventListener('click', function(event) {
            event.preventDefault();
            let url = btnAjax.dataset.href;
            let method = btnAjax.dataset.method;
            let _method = '';
            if(!method) method = "POST";

            if(method == "delete" || method == "DELETE") {
                method = "POST";
                _method = "DELETE";
            } else {
                _method = method;
            }

            axios({
                method: method,
                url: url,
                data: {
                    _method: _method
                },
                responseType: 'stream'
            }).then(function (response) {
                // handle success
                requestSuccess(response.data, response.status, response.headers, btnAjax);
            })
            .catch(function (error) {
                // handle error
                console.log(error);
                requestError(error, btnAjax);
            })
            .then(function () {
                requestFinished(btnAjax);
            });

        }, false)
    });
}

initAjaxForm();
initAjaxButton();

function makeRequest(form, event) {


    var action = form.getAttribute("action");
    var method = form.getAttribute("method");
    const formData = new FormData(form);
    axios({
        method: method,
        url: action,
        data: formData,
        responseType: 'stream'
    }).then(function (response) {
        // handle success
        requestSuccess(response.data, response.status, response.headers, form);
    })
    .catch(function (error) {
        // handle error
        console.log(error);
        requestError(error, form);
    })
    .then(function () {
        requestFinished(form);
    });


}

var loader_button = '';
var loader_text = '';

function requestBeforeSubmit(form) {

    // Pokreni funkciju
    if(form.getAttribute('data-before-run')) window[form.getAttribute('data-before-run')](form);
    // Postavi loader na button
    if(!form.getAttribute('data-loader-false')) {

        if(form.getAttribute('data-loader')) {
            loader_button = form.querySelector(form.getAttribute('data-loader'));
            loader_text = loader_button.innerHTML;
        }

        if (!loader_button) {
            loader_button = form.querySelector('button[type="submit"]');
        }
        if (!loader_button) {
            loader_button = form.querySelector('input[type="submit"]');
        }
        if (!loader_text && loader_button) {
            loader_text = loader_button.innerHTML;
        }
        if (loader_button) {
            loader_button.style.width = loader_button.offsetWidth + 'px';
        }


        if(form.getAttribute('data-loader-text')) var loading_text = form.getAttribute('data-loader-text');
        else var loading_text = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-spin" role="img" aria-hidden="true" style="/*! font-size: 40px; */"><path d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"></path></svg>';
        if (loader_button) {
            loader_button.innerHTML = loading_text;
        }
    }

}

function requestSuccess( data, status, headers, form ) {

    // Pokreni funkciju ako je success
    if(data.success && form && form.getAttribute('data-success-run')) window[form.getAttribute('data-success-run')]( data, status, headers, form );
    // Pokreni funkciju ako je success 2
    if(data.success && form && form.getAttribute('data-success-run2')) window[form.getAttribute('data-success-run2')]( data, status, headers, form );
    // Pokreni funkciju ako je success 3
    if(data.success && form && form.getAttribute('data-success-run3')) window[form.getAttribute('data-success-run3')]( data, status, headers, form );
     // Pokreni funkciju ako je success 4
    if(data.success && form && form.getAttribute('data-success-run4')) window[form.getAttribute('data-success-run4')]( data, status, headers, form );

    // Reload ako je uspješno
    if(data.success && form && form.getAttribute('data-success-reload')) location.reload(true);
    // Modal toggle
    if(data.success && form && form.getAttribute('data-modal-toggle')) {
        //var form_toggle = document.getElementById(form.getAttribute('data-modal-toggle'));
        var form_toggle = window[form.getAttribute('data-modal-toggle')];
        if(form_toggle) form_toggle.toggle();
    }
    // Obriš vrijednosti forme
    if(data.success && form && form.getAttribute('data-clear-form')) clearForm(data,form);

    // Refresh
    if(data.refresh) {
        location.reload(true);
        return;
    }
    //Redirect
    if(data.redirect) {
        location.replace(data.redirect);
        return;
    }

    if(data.success && form && form.getAttribute('data-success-run-after')) window[form.getAttribute('data-success-run-after')]( data, status, headers, form );

    if(form && form.getAttribute('data-sweet')) data.sweet = true;

    if(form && form.getAttribute('data-no-sweet')) data.sweet = false;

    if(form && form.getAttribute('data-no-alert')) return 1;
    // Prikazi obavijesti
    //if(data.sweet) showSweetalert(data);
    //else showNotification(data);
    showNotification(data);

}

function requestError( error, form ) {


    if(form.getAttribute('data-error-run')) window[form.getAttribute('data-error-run')]( data, status, headers, form );
    // Makni loader sa buttona
    if(form.getAttribute('data-loader')) loader_button.innerHTML = loader_text;
    else if(typeof loader_button !== 'undefined' && !form.getAttribute('data-loader-false')) loader_button.innerHTML = loader_text;

    var msg = {error:"Došlo je do greške: " + error};
    //alert(JSON.stringify(data));
    showNotification(msg);

}
function requestFinished( form  ) {

    // Makni loader sa buttona
    if(loader_button && typeof loader_button !== 'undefined' && form && !form.getAttribute('data-loader-false')) loader_button.innerHTML = loader_text;

}


/*

var httpRequest;

let ajaxForms = document.querySelectorAll('.ajax-form');

ajaxForms.forEach(form => {
    form.addEventListener('submit', function(event) {
        event.preventDefault();
        makeRequest(this);
    }, false)
});


function makeRequest(form) {
    httpRequest = new XMLHttpRequest();
    action = form.getAttribute("action");
    method = form.getAttribute("method");
    console.log(form );

    if (!httpRequest) {
        alert('Giving up :( Cannot create an XMLHTTP instance');
        return false;
    }
    httpRequest.onreadystatechange = alertContents;
    httpRequest.open(method, action);
    httpRequest.send();
}

function alertContents() {
    if (httpRequest.readyState === XMLHttpRequest.DONE) {
        if (httpRequest.status === 200) {
            alert(httpRequest.responseText);
        } else {
            alert('There was a problem with the request.');
        }
    }
}
*/
